export const menuItems = [
  { title: "Home", url: "/" },

  {
    title: "Services",
    url: "/services",
    submenu: [
      {
        title: "AWS Consulting & Architecture",
        url: "/services/aws-architecture",
      },
      {
        title: "Cloud-Native Development",
        url: "/services/cloud-development",
      },
      {
        title: "Optimization & Maintenance",
        url: "/services/optimization",
      },
    ],
  },

  {
    title: "Insights",
    url: "/insights",
  },

  {
    title: "About",
    url: "/about",
  },

  {
    title: "Contact",
    url: "/contact",
    isCTA: true,
  },
];